import { DateTime, DateTimeFormatOptions } from 'luxon';

import { ConsumablesOrderStatus } from 'shared';

export function getConsumablesOrderProgressPercent(status: ConsumablesOrderStatus) {
  return {
    open: 10,
    locked: 50,
    delivered: 90
  }[status];
}

export function formatDeliveryDate({
  date,
  format,
  status
}: {
  date?: string | DateTime | null;
  format?: DateTimeFormatOptions;
  status?: ConsumablesOrderStatus;
}) {
  if (!date) return '';

  const dateTime = date instanceof DateTime ? date : DateTime.fromISO(date);
  const inThePast = dateTime.diffNow().days < 0;
  const dateWord = getRelativeDateWord(dateTime) || dateTime.toLocaleString(format);

  return `${inThePast || status === 'delivered' ? 'Arrived' : 'Arriving'} ${dateWord}`;
}

export function getRelativeDateWord(date?: string | DateTime | null) {
  if (!date) return '';

  const dateTime = date instanceof DateTime ? date : DateTime.fromISO(date);
  const dateIsToday = dateTime.startOf('day').equals(DateTime.now().startOf('day'));
  const dateIsTomorrow = dateTime.startOf('day').equals(DateTime.now().plus({ day: 1 }).startOf('day'));
  const dateIsYesterday = dateTime.startOf('day').equals(DateTime.now().minus({ day: 1 }).startOf('day'));

  return dateIsToday ? 'today' : dateIsTomorrow ? 'tomorrow' : dateIsYesterday ? 'yesterday' : '';
}
